import React from 'react';
import { Typography } from '@material-ui/core';
import styles from '../InstructionsStyles';

const Instr4 = () => {
  return (
    <div style={styles.container}>
      <Typography variant="subtitle1" style={styles.madeBy}>
        Утвърдил: Габриела Илиева
      </Typography>

      <Typography variant="subtitle1" style={styles.madeBy}>
        Старши експерт &quot;Здравословна работна среда&quot;
      </Typography>

      <Typography variant="subtitle1" style={styles.title}>
        За безопасна работа при строителство и поддържане на въздушни съобщителни линии и мрежи
        (ВСЛМ)
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>1. До работа по въздушни </b>съобщителни линии и мрежи (ВСЛМ) се допускат техници, които
        имат необходимата правоспособност, преминали са съответно обучение и инструктаж за БР и
        притежават не по-ниска от трета квалификационна група по безопасност на труда съгласно
        изискванията на Правилника по безопасността на труда при работа по въздушни и кабелни
        съобщителни линии и мрежи (Д-06-001).
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          2. При работа е<span style={styles.warning}>задължително </span>
        </b>
        да се използват одобрените и предоставени съобразно степента на риска лични предпазни
        средства, за вида, употребата и начина на съхранение, на които работещите са инструкти- рани
        (и обучени за използването на тези ЛПС, за които това е необходимо).
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          3. <span style={styles.warning}>Забранява се </span>
        </b>
        работа с неизправни лични предпазни средства и с такива с изтекъл срок на годност и на
        периодична проверка.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>4. Развързването и спускането </b>на кабелите от предвидения за подмяна стълб да се
        извършва, като се започне от най-долния кабел, а покачването им върху новопоставения стълб -
        като се започва с най-горния.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>5. Работите по ВСЛМ </b>трябва да се извършват в следната последова- телност:
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - изключване на напрежението;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - идентифициране на въздушната съобщителна линия;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - проверка за отсъствие на напрежение;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - разреждане на металните проводници от електрически заряди към земя;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - повторна проверка за отсъствие на напрежение;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - присъединяване на преносими заземители.
        </Typography>
      </div>
      <Typography variant="body1" style={styles.whiteSpace}>
        6. <b>Не се допуска нарушаване </b>на последователността на изпълнение на техническите
        мероприятия!
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>7. При работа по въздушни </b>съобщителни линии местата на сближение или пресичане с
        въздушни електропроводни линии техникът задължително трябва да проверява с волтметър за
        отсъствие на напрежение спрямо земя в проводниците на съобщителната линия. При наличие на
        напрежение в съобщителната линия работата да се преустанови до отстраняване на напрежението.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          8. <span style={styles.warning}>Забранява се</span>{' '}
        </b>
        извършването на работи по ВСЛМ по време на активна атмосферна /мълниеносна/ дейност.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>9. Задължително се преустановяват работите по ВСЛМ при:</b> силен снеговалеж, ниски
        температури на въздуха, заледени и необезопасени работни места, гъста мъгла, през тъмната
        част на денонощието или при прекъсване на изкуственото осветление, както и при скорост на
        вятъра над 12 m/sec.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          10. <span style={styles.warning}>Забранява се </span>
        </b>
        работа по ВСЛМ до пътища, железопътни и трамвайни линии на техници без специално работно
        облекло със светло-отразителни знаци.
      </Typography>

      <Typography style={styles.date}>
        <b>7.10.2024г.</b>
      </Typography>
    </div>
  );
};
export default Instr4;
